import { injectIntl } from 'react-intl';

const GroupPerformance = ({ intl }) => {
  if (intl.locale === 'en') {
    return (
      <>
        They aim to improve the site's performance by gathering anonymized data
        on navigation and the use of available resources. If you do not allow
        the gathering of cookies, this data will not be used to improve the
        website.
      </>
    );
  }

  return (
    <>
      Visam a melhoria do desempenho do site por meio da coleta de dados
      anonimizados sobre navegação e uso dos recursos disponibilizados. Se você
      não permitir a coleta desses cookies, esses dados não serão usados para
      melhoria do site.
    </>
  );
};

export default injectIntl(GroupPerformance);
